// Legacy shim - tracking now goes through /api/analytics/*
import { trackVisit as apiTrackVisit, trackEvent as apiTrackEvent } from '../api/services';

export function trackVisit(page) {
  return apiTrackVisit(page);
}

export function trackClick(type, meta = {}) {
  return apiTrackEvent(type, meta);
}

// Legacy admin panel helpers (fallback for offline)
export function getAnalytics() {
  return { events: [], visits: [] };
}

export function clearAnalytics() {
  // no-op
}
